import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { ProfessionalTransfersReportService } from "src/app/shared/services/professional-transfers-report.service";
import { ProfessionalTransfersReportActions } from "./professional-transfers-report.actions";
import { NotifyService } from "src/app/shared/services/notify.service";

@Injectable()

export class ProfessionalTransfersReportEffects {

    constructor(
        private service: ProfessionalTransfersReportService,
        private action$: Actions,
        private notify: NotifyService
    ) { }

    loadProfessionalTransfersReport$ = createEffect(() =>
        this.action$.pipe(
            ofType(ProfessionalTransfersReportActions.loadProfessionalTransfersReport),
            exhaustMap(() =>
                this.service
                    .get()
                    .pipe(
                        map((res) => ProfessionalTransfersReportActions.loadProfessionalTransfersReportSuccess({ professional_transfers_report: res })),
                        catchError((error) => {
                            this.notify.emitError('Falha ao carregar registros')
                            return of(error.error['hydra:description'])
                        })
                    
                    )
            )
        )
    )

}
